import { Component, OnInit } from '@angular/core';
import {LoadingController, NavController} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-qrcode-process',
  templateUrl: './qrcode-process.page.html',
  styleUrls: ['./qrcode-process.page.scss'],
})
export class QrcodeProcessPage implements OnInit {
  product: any = null;
  qrcode: string = null;

  constructor(private navController: NavController,
              private route: ActivatedRoute,
              private loadingController: LoadingController,
              private apiService: ApiService,
              ) { }

  ngOnInit() {
    this.qrcode = this.route.snapshot.paramMap.get('qrcode');
    this.apiService.qrcodeApi.getPrivate(this.qrcode).then((qr: any) => {
      if (qr.goodStatus === 'VENDU'){
        this.navController.navigateForward('/home/' + this.qrcode + '/professional-buy');
      }
      else if (qr.qrcode?.canrecover === true){
        this.navController.navigateForward('/home/' + this.qrcode + '/recover');
      }

      this.product = qr;
    }).catch((res) => {
      this.navController.navigateBack('/home');
    });
  }

}
